import { elicePalettes, type2Palettes, type1Palettes } from '../palettes';

import type {
  Publisher,
  PublisherSubjects,
  SubjectLevels,
  ThemeColor,
} from '../palettes/types';

const getThemeColors = (
  publisher: Publisher,
  subject: keyof PublisherSubjects,
  level: keyof SubjectLevels
): ThemeColor => {
  let AIDTThemeColors;

  switch (publisher) {
    case 'type1':
      AIDTThemeColors = type1Palettes;
      break;

    case 'type2':
      AIDTThemeColors = type2Palettes;
      break;

    default:
      AIDTThemeColors = elicePalettes;
  }

  return (
    AIDTThemeColors[subject]?.[level] || {
      primary: '#000000',
      background: '#FFFFFF',
      secondary: '#555555',
      black: '#132234',
      light: '#E2E2E2',
    }
  );
};

export { getThemeColors };
